import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "tag", "children", "icon", "size", "mode", "theme", "disabled", "disableCursor", "selected", "highlighted", "iconPlacement"],
    _excluded2 = ["unregisterItem", "registerItem", "activeItemRef", "isKeyboardNavigating", "wrapWithLi"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect, cloneElement, Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTheme } from '@rescui/ui-contexts';
import styles from '../index.p.module.css.js';
import { useMenuContext } from './menu-context.js';
var ICON_PLACEMENT_STYLES = {
  left: styles.placementLeft,
  right: styles.placementRight
};
var MODE_STYLES = {
  classic: styles.modeClassic,
  clear: styles.modeClear,
  rock: styles.modeRock
};
var SIZE_STYLES = {
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};
var THEME_STYLES = {
  light: styles.themeLight,
  dark: styles.themeDark
}; // eslint-disable-next-line complexity

var MenuItemInner = function MenuItemInner(_ref, ref) {
  var _menuContext$theme, _ref2, _menuContext$itemTag, _ref3, _menuContext$iconPlac, _menuContext$mode, _menuContext$size, _menuContext$disableC;

  var className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'classic' : _ref$mode,
      theme = _ref.theme,
      disabled = _ref.disabled,
      disableCursor = _ref.disableCursor,
      selected = _ref.selected,
      highlighted = _ref.highlighted,
      _ref$iconPlacement = _ref.iconPlacement,
      iconPlacement = _ref$iconPlacement === void 0 ? 'left' : _ref$iconPlacement,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useMenuContext = useMenuContext(),
      unregisterItem = _useMenuContext.unregisterItem,
      registerItem = _useMenuContext.registerItem,
      activeItemRef = _useMenuContext.activeItemRef,
      isKeyboardNavigating = _useMenuContext.isKeyboardNavigating,
      wrapWithLi = _useMenuContext.wrapWithLi,
      menuContext = _objectWithoutProperties(_useMenuContext, _excluded2);

  var actualTheme = useTheme((_menuContext$theme = menuContext.theme) !== null && _menuContext$theme !== void 0 ? _menuContext$theme : theme);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      thisRef = _useState2[0],
      setThisRef = _useState2[1];

  useEffect(function () {
    return function () {
      return unregisterItem(thisRef);
    };
  }, [unregisterItem, thisRef]);
  var autoTag = 'span';

  if (restProps.href) {
    autoTag = 'a';
  } else if (restProps.onClick) {
    autoTag = 'button';
  }

  var Tag = (_ref2 = (_menuContext$itemTag = menuContext.itemTag) !== null && _menuContext$itemTag !== void 0 ? _menuContext$itemTag : tag) !== null && _ref2 !== void 0 ? _ref2 : autoTag;
  var actualIconPlacement = (_ref3 = (_menuContext$iconPlac = menuContext.iconPlacement) !== null && _menuContext$iconPlac !== void 0 ? _menuContext$iconPlac : iconPlacement) !== null && _ref3 !== void 0 ? _ref3 : 'left';
  var actualMode = (_menuContext$mode = menuContext.mode) !== null && _menuContext$mode !== void 0 ? _menuContext$mode : mode;
  var actualSize = (_menuContext$size = menuContext.size) !== null && _menuContext$size !== void 0 ? _menuContext$size : size;
  var actualDisableCursor = (_menuContext$disableC = menuContext.disableCursor) !== null && _menuContext$disableC !== void 0 ? _menuContext$disableC : disableCursor;
  var iconElement = icon ? /*#__PURE__*/cloneElement(icon, {
    className: cn(icon.props.className, styles.icon)
  }) : null;
  var actualHighlighted = highlighted || activeItemRef === thisRef && isKeyboardNavigating;

  var handleRef = function handleRef(r) {
    registerItem(r);
    setThisRef(r);

    if (typeof ref === 'function') {
      ref(r);
    } else if (ref != null && _typeof(ref) === 'object') {
      ref.current = r;
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (isKeyboardNavigating && (e.key === ' ' || e.key === 'Enter')) {
      e.preventDefault();

      if (e.target && e.target.click) {
        e.target.click();
      }
    }
  };

  var Wrapper = wrapWithLi ? 'li' : Fragment;
  var wrapperProps = wrapWithLi ? {
    className: styles.wrapper
  } : {};
  return /*#__PURE__*/React.createElement(Wrapper, _objectSpread({}, wrapperProps), /*#__PURE__*/React.createElement(Tag, _objectSpread({
    onKeyDown: handleKeyDown,
    ref: handleRef,
    className: cn(styles.menuItem, ICON_PLACEMENT_STYLES[actualIconPlacement], MODE_STYLES[actualMode], SIZE_STYLES[actualSize], THEME_STYLES[actualTheme], (menuContext.disabled || disabled) && styles.disabled, selected && styles.selected, actualHighlighted && styles.highlighted, actualDisableCursor && styles.disableCursor, className),
    "data-test": 'menu-item',
    tabIndex: 0
  }, restProps), actualIconPlacement === 'left' && iconElement, /*#__PURE__*/React.createElement("span", {
    className: styles.content
  }, children), actualIconPlacement === 'right' && iconElement));
};

var MenuItem = /*#__PURE__*/React.forwardRef(MenuItemInner);
MenuItem.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's']),
  mode: PropTypes.oneOf(['clear', 'classic', 'rock']),
  theme: PropTypes.oneOf(['light', 'dark']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  disableCursor: PropTypes.bool,
  selected: PropTypes.bool,

  /** @ignore */
  highlighted: PropTypes.bool,
  icon: PropTypes.element,
  iconPlacement: PropTypes.oneOf(['left', 'right']),
  tag: PropTypes.elementType
};
export { MenuItem, MenuItem as default };
